module.exports = __webpack_public_path__ + "img/16d001-07.bcd6fda3.png";